const Order = { ASC: 'asc', DESC: 'desc' }

export { Order }
